import { defineMessages } from 'react-intl-next';

export const messages: {
    addItemText: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	addItemText: {
		id: 'company-hub.company-hub-common.config-panel.add-card-cta',
		defaultMessage: 'Add card',
		description: 'Button that allows the user to add a new card to their Link Cards extension',
	},
});
